const resizeImage = async (base64: string, maxWidth: number = 215, maxHeight: number = 230): Promise<string> => {
    const img = document.createElement('img');

    await new Promise(resolve => {
        img.onload = resolve;
        img.src = base64;
    });

    const canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    ctx.drawImage(img, 0, 0);

    let width = img.naturalWidth,
        height = img.naturalHeight;

    if (width > height) {
        if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
        }
    } else {
        if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
        }
    }

    canvas.width = width;
    canvas.height = height;
    ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    ctx.drawImage(img, 0, 0, width, height);

    return canvas.toDataURL('image/jpeg', 0.99);
};

export default resizeImage;